import { BOLT_BOOTSTRAP_ID } from '~/lib/constants';
import { snapshotManager } from '~/lib/snapshots/snapshot-manager';
import { projectStore } from '~/lib/stores/project';
import { workbenchStore } from '~/lib/stores/workbench';
import type { AssistantMessage, Message } from '~/types/chat';

export function createSnapshot(messages: Message[], restorePoint?: Message['id']) {
  const lastAssistantResponse = messages.findLast(({ id, role }) => {
    return role === 'assistant' && id !== BOLT_BOOTSTRAP_ID;
  }) as AssistantMessage | undefined;

  const messageId = restorePoint ?? lastAssistantResponse?.messageId ?? lastAssistantResponse?.id;
  const projectId = projectStore.getProjectId();
  const hasSnapshot = snapshotManager.hasSnapshot(messageId);

  if (!messageId || !projectId || hasSnapshot) {
    return false;
  }

  snapshotManager.create(projectId, messageId, workbenchStore.files.get());

  return true;
}
